import { useParams } from 'next/navigation';

import { routes } from '~constants/routes';
import { annals } from '~features/annals/hooks';
import { useSession } from '~hooks/useSession';
import ImageIcon from '~public/assets/icons/image-black.svg';
import { useGetBotStatsQuery } from '~services/api/bots/endpoints';

import { MediaButton, SendComp } from './styles';

type TSendButton = {
	disabled: boolean;
	onSend: () => void;
};
export const SendButton = ({ disabled, onSend }: TSendButton) => {
	const { recipientId } = useParams<{ recipientId: string }>();
	const { userId } = useSession();
	const { data: stats } = useGetBotStatsQuery(
		{
			userId,
			recipientId,
		},
		{
			refetchOnMountOrArgChange: true,
			skip: !recipientId || !userId,
		}
	);
	const totalMediaCount = stats?.totalMediaCount;
	const annalsSendMsgButton = annals.chat.useSendMsgButton();
	const logOpenBotProfile = annals.botProfile.useBotProfileOpened({
		source: 'gallery',
		botClientId: recipientId,
	});

	const handleClick = () => {
		onSend();
		void annalsSendMsgButton();
	};

	const onOpenBotProfileClicked = () => {
		logOpenBotProfile();
	};

	if (disabled) {
		return (
			<MediaButton
				onClick={onOpenBotProfileClicked}
				href={routes.profile.slug(recipientId)}
				rightIcon={<ImageIcon />}
				size="S"
			>
				{totalMediaCount || ''}
			</MediaButton>
		);
	}

	return <SendComp onClick={handleClick} disabled={disabled} />;
};
